/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetWeaknessInstanceDto } from './AssetWeaknessInstanceDto';
import {
    AssetWeaknessInstanceDtoFromJSON,
    AssetWeaknessInstanceDtoFromJSONTyped,
    AssetWeaknessInstanceDtoToJSON,
    AssetWeaknessInstanceDtoToJSONTyped,
} from './AssetWeaknessInstanceDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { OpenWeaknessCountSnapshot } from './OpenWeaknessCountSnapshot';
import {
    OpenWeaknessCountSnapshotFromJSON,
    OpenWeaknessCountSnapshotFromJSONTyped,
    OpenWeaknessCountSnapshotToJSON,
    OpenWeaknessCountSnapshotToJSONTyped,
} from './OpenWeaknessCountSnapshot';

/**
 * 
 * @export
 * @interface AssetWeaknessViewResponse
 */
export interface AssetWeaknessViewResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessViewResponse
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessViewResponse
     */
    assetClass?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetWeaknessViewResponse
     */
    openInstanceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetWeaknessViewResponse
     */
    materializedOpenWeaknessCount?: number;
    /**
     * 
     * @type {OpenWeaknessCountSnapshot}
     * @memberof AssetWeaknessViewResponse
     */
    materializedSeverityBreakdown?: OpenWeaknessCountSnapshot;
    /**
     * 
     * @type {Array<AssetWeaknessInstanceDto>}
     * @memberof AssetWeaknessViewResponse
     */
    openInstances?: Array<AssetWeaknessInstanceDto>;
    /**
     * 
     * @type {number}
     * @memberof AssetWeaknessViewResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessViewResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AssetWeaknessViewResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AssetWeaknessViewResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AssetWeaknessViewResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the AssetWeaknessViewResponse interface.
 */
export function instanceOfAssetWeaknessViewResponse(value: object): value is AssetWeaknessViewResponse {
    return true;
}

export function AssetWeaknessViewResponseFromJSON(json: any): AssetWeaknessViewResponse {
    return AssetWeaknessViewResponseFromJSONTyped(json, false);
}

export function AssetWeaknessViewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetWeaknessViewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'openInstanceCount': json['openInstanceCount'] == null ? undefined : json['openInstanceCount'],
        'materializedOpenWeaknessCount': json['materializedOpenWeaknessCount'] == null ? undefined : json['materializedOpenWeaknessCount'],
        'materializedSeverityBreakdown': json['materializedSeverityBreakdown'] == null ? undefined : OpenWeaknessCountSnapshotFromJSON(json['materializedSeverityBreakdown']),
        'openInstances': json['openInstances'] == null ? undefined : ((json['openInstances'] as Array<any>).map(AssetWeaknessInstanceDtoFromJSON)),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function AssetWeaknessViewResponseToJSON(json: any): AssetWeaknessViewResponse {
    return AssetWeaknessViewResponseToJSONTyped(json, false);
}

export function AssetWeaknessViewResponseToJSONTyped(value?: AssetWeaknessViewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'openInstanceCount': value['openInstanceCount'],
        'materializedOpenWeaknessCount': value['materializedOpenWeaknessCount'],
        'materializedSeverityBreakdown': OpenWeaknessCountSnapshotToJSON(value['materializedSeverityBreakdown']),
        'openInstances': value['openInstances'] == null ? undefined : ((value['openInstances'] as Array<any>).map(AssetWeaknessInstanceDtoToJSON)),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

